import {
  faBackward,
  faExternalLinkAlt,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { Comparator } from "react-bootstrap-table2-filter";
import { withRouter } from "react-router-dom";
import { labels } from "../../../localization/labels";
import { messages } from "../../../localization/messages";
import { selectFilter, trueFilter } from "../../../services/FilteringUtils";
import KnowledgeService from "../../../services/KnowledgeService";
import CommonUtil from "../../../utils/CommonUtil";
import { constants } from "../../../utils/Constants";
import PathUtil from "../../../utils/PathUtil";
import RouteUtil from "../../../utils/RouteUtil";
import SecurityUtils from "../../../utils/SecurityUtils";
import TableUtils from "../../core/Table/TableUtils";
import { paths } from "../../paths";
import AdvancedSearchComponent from "../page/AdvancedSearchComponent/AdvancedSearchComponent";
import { knowledge_item_ASPS } from "../page/AdvancedSearchComponent/advanced_search_parameters";
import KnowledgeManagement from "./KnowledgeManagement";

class KnowledgeManagementContainer extends AdvancedSearchComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      pageInfo:
        RouteUtil.getLocationParameter(props, "pageInfo") ||
        this.initialPageInfo(),
      advancedSearchParams: RouteUtil.getLocationParameter(
        props,
        "advancedSearchParams"
      ),
      contextMenuItems: [
        {
          label: labels.newTab,
          callback: this.openInNewTab,
          menuItemType: constants.MENU_ITEM_TYPE_NEW_TAB,
          checkSecurity: true,
          icon: (
            <FontAwesomeIcon className="contextIcon" icon={faExternalLinkAlt} />
          )
        },
        {
          label: labels.reactivateItem,
          callback: this.handleOnReactivate,
          menuItemType: constants.MENU_ITEM_TYPE_REACTIVATE,
          checkSecurity: true,
          icon: <FontAwesomeIcon className="contextIcon" icon={faBackward} />
        },
        {
          label: labels.deactivate,
          callback: this.handleOnDelete,
          menuItemType: constants.MENU_ITEM_TYPE_DELETE,
          checkSecurity: true,
          icon: <FontAwesomeIcon className="contextIcon" icon={faTrash} />
        }
      ]
    };
    this.customContextRef = React.createRef();
    this.knowledgeService = new KnowledgeService(this.keycloak);
    this.columns = this.initColumns();
  }

  initialState() {
    return {
      ...super.initialState(),

      show: false,
      includeActiveDropdown: this.props.isElasticSearch
        ? false
        : this.props.includeActiveDropdown,
      includeAdvancedSearchButton: this.props.isElasticSearch
        ? false
        : this.props.includeAdvancedSearchButton,
      includeAddButton: this.props.includeAddButton,
      includeSearch: this.props.isElasticSearch
        ? true
        : this.props.includeSearch
    };
  }

  handleOnDelete = entity => {
    const confirmed = window.confirm(messages.deactivate_confirm_message);
    if (confirmed) {
      this.onDeleteData(entity);
    }
  };

  initialSortInfo() {
    return {
      orderBy: "id",
      direction: "desc"
    };
  }

  getExcludeSortFilters = () => {
    return this.props.isElasticSearch;
  };

  initColumns() {
    return super.initColumns([
      {
        dataField: "id",
        text: labels.id,
        sort: this.getExcludeSortFilters() ? false : true,
        formatter: TableUtils.textFormatter,
        classes: "column-id",
        headerClasses: this.state.excludeSortFilters
          ? "column-header-id"
          : "column-header-id-filtered",
        headerFormatter: this.formatHeader,
        filter: this.getExcludeSortFilters()
          ? undefined
          : TableUtils.textFilter(
              labels.id,
              Comparator.EQ,
              this.state.pageInfo.filters.id?.filterVal
            )
      },
      {
        dataField: "name",
        text: labels.name,
        sort: this.getExcludeSortFilters() ? false : true,
        formatter: TableUtils.textFormatter,
        headerClasses: this.getExcludeSortFilters()
          ? "column-header"
          : "column-header-filtered",
        headerFormatter: this.formatHeader,
        filter: this.getExcludeSortFilters()
          ? undefined
          : TableUtils.textFilter(
              labels.name,
              undefined,
              this.state.pageInfo.filters.name?.filterVal
            )
      },
      {
        dataField: "description",
        text: labels.description,
        formatter: TableUtils.textFormatter,
        sort: this.getExcludeSortFilters() ? false : true,
        headerClasses: this.getExcludeSortFilters()
          ? "column-header"
          : "column-header-filtered",
        headerFormatter: this.formatHeader,
        filter: this.getExcludeSortFilters()
          ? undefined
          : TableUtils.textFilter(
              labels.description,
              undefined,
              this.state.pageInfo.filters.description?.filterVal
            )
      }
    ]);
  }

  getComponentTitle = () => {
    return labels.knowledgeManagement;
  };

  loadData = pageInfo => {
    this.adjustPageInfo(pageInfo);
    this.prepareCall(
      this.knowledgeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  adjustPageInfo = pageInfo => {
    if (this.props.tag) {
      pageInfo.filters = {
        ...pageInfo.filters,
        tags: selectFilter(this.props.tag.fullText)
      };
    }
    if (this.props.classification) {
      pageInfo.filters = {
        ...pageInfo.filters,
        classifications: selectFilter(this.props.classification.id),
        fetchParentClassificationsOnly: trueFilter
      };
    }

    super.adjustPageInfo(pageInfo);
  };

  componentDidMount() {
    super.componentDidMount();
  }

  resetComponent() {
    super.resetComponent();
    this.columns = this.initColumns();
  }

  componentDidUpdate(prevProps) {
    this.shouldResetFilters = true;
    super.componentDidUpdate();

    if (
      prevProps.tag !== this.props.tag ||
      prevProps.classification !== this.props.classification
    ) {
      this.startLoading(this.initialPageInfo(), this.sortInfo);
    }
  }

  onRowClick = (_, row) => {
    if (
      SecurityUtils.partyHasPermissionOnEntity(row, constants.OPERATION_READ)
    ) {
      const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, row.id);
      this.props.history.replace(paths.KNOWLEDGE_MANAGMENT, {
        pageInfo: this.state.pageInfo
      });
      this.changePath(itemPath, row.name);
    } else return undefined;
  };

  onDeleteData = knowledgeItem => {
    this.prepareCall(
      this.knowledgeService.deleteEntity(
        knowledgeItem,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onReactivateData = knowledgeItem => {
    const oldKnowledgeItem = CommonUtil.jsonCopy(knowledgeItem);
    knowledgeItem.isDeleted = false;
    this.prepareCall(
      this.knowledgeService.patchEntity(
        knowledgeItem,
        oldKnowledgeItem,
        this.onDataReactivateResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
    this.performCalls();
  };

  handleCreate = () => {
    this.changePath(paths.KNOWLEDGE_ITEM, labels.knowledgeItem);
  };

  getAdvancedSearchParams = () => {
    var { advancedSearchParams } = this.state;
    if (
      advancedSearchParams === undefined ||
      Object.entries(advancedSearchParams).length === 0
    ) {
      advancedSearchParams = knowledge_item_ASPS;
    }
    return advancedSearchParams;
  };

  openInNewTab = row => {
    const itemPath = PathUtil.itemPath(paths.KNOWLEDGE_ITEM, row.id);
    window.open(itemPath, "_blank", "noopener");
  };

  createSelectRow = () => {};

  render() {
    return (
      <KnowledgeManagement
        {...this.renderProps()}
        {...this.handlerProps()}
        cellEditProps={this.cellEditProps}
        handleCreate={this.handleCreate}
        contextMenuItems={this.state.contextMenuItems}
        headerTitle={this.props.headerTitle}
        includeAddButton={this.state.includeAddButton}
        includeAdvancedSearchButton={this.state.includeAdvancedSearchButton}
        includeActiveDropdown={this.state.includeActiveDropdown}
        dontShowTable={this.state.dontLoadAfterMount && !this.state.showTable}
      />
    );
  }
}

export default withKeycloak(withRouter(KnowledgeManagementContainer));
